import { replace } from "lodash";
import numeral from "numeral";
import millify from "millify";

// ----------------------------------------------------------------------

export function fCurrency(number) {
  return numeral(number).format(Number.isInteger(number) ? "$0,0" : "$0,0.00");
}

export function fPercent(number) {
  return numeral(number / 100).format("0.0%");
}

export function fNumber(num) {
  return replace(numeral(num).format("0.00a"), ".00", ".00");
}

export function fShortenNumber(number) {
  return replace(numeral(number).format("0.00a"), ".00", "");
}

export function fData(number) {
  return numeral(number).format("0.0 b");
}

export function get_kmb_number(number) {
  if (number) {
    return millify(number, { precision: 1 });
  } else {
    return number;
  }
}
